(function () {
  const BADGE_SRC =
    'https://cdn.shopify.com/s/files/1/0910/9374/files/Group_2085664980.png?v=1774543122';

  function primaryGallery() {
    return document.querySelector('media-gallery[id^="MediaGallery-"]:not([id$="-duplicate"])');
  }

  function firstSlideContainer(gallery) {
    if (!gallery) return null;
    const list = gallery.querySelector('ul.product__media-list');
    if (!list) return null;
    const firstLi = list.querySelector(':scope > li.product__media-item');
    if (!firstLi) return null;
    if (!firstLi.querySelector('.product__media.media.media--transparent img')) return null;
    return firstLi.querySelector(':scope > .product-media-container');
  }

  function inject() {
    const gallery = primaryGallery();
    const container = firstSlideContainer(gallery);
    if (!container || container.querySelector('.ir-clean-label-gallery-badge')) return;
    container.classList.add('ir-clean-label-gallery-anchor');
    const wrap = document.createElement('span');
    wrap.className = 'ir-clean-label-gallery-badge';
    wrap.setAttribute('aria-hidden', 'true');
    const badgeImg = document.createElement('img');
    badgeImg.src = BADGE_SRC;
    badgeImg.alt = '';
    badgeImg.width = 125;
    badgeImg.height = 122;
    badgeImg.loading = 'lazy';
    badgeImg.decoding = 'async';
    wrap.appendChild(badgeImg);
    container.appendChild(wrap);
  }

  function run() {
    inject();
    requestAnimationFrame(() => inject());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
